/* eslint-disable */

import React from "react";

class Device extends React.Component<any, any> {
	render() {
		return (
			<div className="device-wrapper iPhone7">
				<div className="device" data-device="iPhone7" data-orientation="portrait" data-color="black">
					<div className="screen">{this.props.children}</div>
					<div className="button" />
				</div>
			</div>
		);
	}
}

export default Device;
